import { useEffect } from 'react'

import { Outlet, useLoaderData } from 'react-router-dom'

import FrontFooter from '../Navigation/frontend/FrontFooter'

import request from '../Functions/ajax/request'

import RolesStore from '../../Stores/Roles'
import setRolesStore from '../../StoresFunctions/setRolesStore'

import SuspendedLayout from '../../SuspendedLayout'

export default function EntityLayout ()
{
	const { page } = useLoaderData();

	const roles_status = RolesStore.useState(s => s.status);

	useEffect(() =>
	{
		if (roles_status !== 'pending') return;

		const controller = new AbortController();

		(async function fetchRoles ()
		{
			try
			{
				var { roles, user_id } = await request('/auth/get-roles')
				.config({ controller })
				.post();
			}
			catch (update)
			{
				return;
			}

			setRolesStore({ roles, user_id });
		})();

		return () => controller?.abort?.();
	},
	[roles_status]);

	return (
		<SuspendedLayout resolve={ page }>

			<div className="front-page entity-one-page">
				<Outlet />
				<FrontFooter layout="entity" />
			</div>

		</SuspendedLayout>
	);
}